// extracted by mini-css-extract-plugin
export default {"colorTitle":"nNN9_P2"};